/**
 * @file   src\pages\Messaging.js
 * @brief  This file is responsible for handling messaging/chat screen.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {
  getLocalStorage,
  getUserType,
  loggedInUser,
} from "../../helpers/common";
import { USER_INFO_KEY, USER_TYPE_AGENT } from "../../constants/common";
import DirectMessagesRightSection from "../../components/Messages/DirectMessagesRightSection";
import { loginOrSignUp } from "../../helpers/message";
import IntroDetails from "../../components/Messages/IntroDetails";
import AgentProfileViewModal from "../../components/Introduction/AgentProfileViewModal";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import { pageURLs } from "@/constants";
import { getDirectChats } from "../../services/messagesService";
import DirectMessageLeftSection from "../../components/Messages/DirectMessageLeftSection";
import { getUserProfileForDM } from "../../services/v2/agentProfile";
import { PageWrapper } from "@/components/PageWrapper";
import { useMLSAgentAtGitchaHomeRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";

const DirectMessages = (props) => {

  const navigate = useNavigate();
  const [directChats, setDirectChats] = useState([]);
  const sessionData = getLocalStorage(USER_INFO_KEY);
  //user's own info
  const userId = _.get(sessionData, "userInfo.userId", "");
  const [filter, setFilter] = useState("all");
  const userDetails = loggedInUser();
  const [showViewIntroductionModal, setViewIntroductionModal] = useState(false);
  const handleIntroDetailModal = (modalState) =>
    setViewIntroductionModal(modalState);
  const [introDetails, setIntroDetails] = useState([]);
  const [showProfileModal, setProfileModal] = useState(false);
  const ProfileModalClose = () => setProfileModal(false);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [isFromMessage, setIsFromMessage] = useState(false);

  const [message, setMessages] = useState("");

  const chatMessages = useSelector((state) => state.unreadCount.chatMessages);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const chatId = params.get("id");
  const [agentProfile, setAgentProfile] = useState(null);
  const [showChatOnMobile, setShowChatOnMobile] = useState(false);

  //GET SELECTED AGENT DETAILS
  const getAgentDetails = async (slug) => {
    await getUserProfileForDM(slug)
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          setAgentProfile(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        navigate(pageURLs.directMessages);
        console.log("Error", err);
      });
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const chatId = params.get("id");
    if (chatId) {
      getAgentDetails(chatId);
      setShowChatOnMobile(true);
    } else {
      setShowChatOnMobile(false);
    }
  }, [location.search, getUserProfileForDM]);

  useEffect(() => {
    let email = _.get(userDetails, "userInfo.email", null);
    let login = loginOrSignUp(email);

    if (!login) {
      navigate(pageURLs.home);
    }
  }, []);


  useEffect(() => {
    getDirectChatsLeft();
  }, [chatId]);

  const updateLastMessage = (chatId, lastMessage) => {
    const chat = directChats.find((item) => item.id === chatId);
    if (chat) {
      chat.lastMessage = lastMessage;
      chat.lastMessageAt = new Date().getTime();
      setDirectChats([...directChats]);
    } else {
      getDirectChatsLeft();
    }
  };
  useEffect(() => {
    let fetchedMessages = chatMessages?.payload;
    let orderd = [];
    if (fetchedMessages) {
      let assignedToMe = fetchedMessages?.filter(
        (item) =>
          item.wantAdCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );
      let assignedByMe = fetchedMessages?.filter(
        (item) =>
          item.inventroyCreatedId == userId &&
          item.isaccepted == true &&
          item.isdeleted == false,
      );

      orderd = [...assignedToMe, ...assignedByMe];

      let allCountLabel =
        orderd && orderd.length > 0
          ? "All conversations (" + orderd.length + ")"
          : "All conversations";
      let sentByMeCountLabel =
        assignedByMe && assignedByMe.length > 0
          ? "Introductions sent (" + assignedByMe.length + ")"
          : "Introductions sent";
      let sentToMeCountLabel =
        assignedToMe && assignedToMe.length > 0
          ? "Introduced to me (" + assignedToMe.length + ")"
          : "Introduced to me";

      if (filter == "intro_to_me") {
        const doEmptyAction = assignedToMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedToMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
        }
      } else if (filter == "intro_sent") {
        const doEmptyAction = assignedByMe.every((o) => o.createdat);
        if (doEmptyAction) {
          orderd = assignedByMe.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderd);
        }
      } else {
        const doEmptyAction = orderd.every((o) => o.createdat);
        if (doEmptyAction) {
          let orderdNew = orderd.sort((a, b) => b.createdat - a.createdat);
          setMessages(orderdNew);
        }
      }
    } else {
      setMessages([]);
    }
  }, [chatMessages, filter]);
  /**
   * To get introduction details
   * @param {*} introductionId
   */
  const getDirectChatsLeft = async () => {
    await getDirectChats()
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setDirectChats(responseResult);
        if (response.errorCode === 0 && responseResult) {
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const ViewProfile = (agentId, isFromMessageScreen = false) => {
    handleIntroDetailModal(false);
    setIsFromMessage(isFromMessageScreen);
    setSelectedUserId(agentId);
    setProfileModal(true);
  };

  const closeAgentModal = (isFromMessage) => {
    if (!isFromMessage) {
      handleIntroDetailModal(true);
    }
    setProfileModal(false);
  };

  useMLSAgentAtGitchaHomeRedirect();

  return (
    <>
      <PageWrapper>
        <div className="m-0">
          <div className="main-content p-0 agent-no-login-content">
            <div className="msg-tab">
              <Tabs
                defaultActiveKey="direct-message"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(key) => {
                  if (key === "messages") {
                    navigate("/messages");
                  } else {
                    navigate("/direct-messages");
                  }
                }}
              >
                <Tab eventKey="messages" title="Introduction Messages">
                  Introduction Messgaes
                </Tab>
                <Tab eventKey="direct-message" title="Direct Messages">
                  <div className={`row msg-height ${showChatOnMobile ? "mobile-chat-active" : ""}`}>
                    <div className="col-12 col-md-6 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2 mb-4 mb-sm-4 mb-md-0 msg-left-col">
                      <div className="ad-strengthen-wrap strengthen-adjust-wrap mh-490 pe-0 ps-0 pt-0 pb-2">
                        <div className="messaging-top-header pb-12 pl-16 pr-16 pt-4">
                          <h3>Messages</h3>
                        </div>

                        <DirectMessageLeftSection messages={directChats} />
                      </div>
                    </div>
                    {chatId && (
                      <DirectMessagesRightSection
                        updateLastMessage={updateLastMessage}
                        userId={userId}
                        agentProfile={agentProfile}
                        onMobileBack={() => {
                          setShowChatOnMobile(false);
                          setAgentProfile(null);
                          navigate("/direct-messages", { replace: true });
                        }}
                      />
                    )}
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </PageWrapper>
      <IntroDetails
        details={introDetails}
        show={showViewIntroductionModal}
        onHide={handleIntroDetailModal}
        ViewProfileModal={(agentId) => {
          ViewProfile(agentId);
        }}
        userDeleted={false}
      />

      <AgentProfileViewModal
        show={showProfileModal}
        onHide={ProfileModalClose}
        userId={selectedUserId}
        isFromMessage={isFromMessage}
        onClose={(isFromMessage) => {
          closeAgentModal(isFromMessage);
        }}
      />
    </>
  );
};

export default DirectMessages;
